import React, { FC, memo } from 'react';
import { useField } from 'formik';

import usePrefix from 'utils/usePrefix';
import TextAreaComponent from 'components/TextAreaComponent';
import FormDescription from 'components/ResqlExpert/FormDescription';

import { FormSectionStyled, TabBodyContentStyled } from './styles';

interface Props {
  fieldName: string;
  titleKey: string;
  hintKey: string;
}

const SingleFieldTab: FC<Props> = ({ fieldName, titleKey, hintKey }) => {
  const t = usePrefix('ResqlExpert');
  const [field, , helpers] = useField<string>(fieldName);
  const value = field.value ?? '';

  return (
    <TabBodyContentStyled>
      <FormSectionStyled>
        <FormDescription title={t(titleKey)}>
          {hintKey ?
            // eslint-disable-next-line react/no-danger
            <div dangerouslySetInnerHTML={{ __html: t(hintKey) }} /> : null
          }
        </FormDescription>
        <TextAreaComponent
          id={fieldName}
          label={t(titleKey)}
          placeholder={t(titleKey)}
          text={value}
          setText={(v) => helpers.setValue(v)}
        />
      </FormSectionStyled>
    </TabBodyContentStyled>
  );
};

export default memo(SingleFieldTab);
